import React, { useEffect, useState } from "react";
import Breadcrumbs from "../common/breadcrumbs";
import Aos from "aos";
import DashboardMenu from "./common/dashboard-menu";
import UserDashboardOnly from "./pages/dashboard";
import UserBookingsNew from "./pages/userbookings";
import UserTransactions from "./pages/userTransactions";
import UserReview from "./pages/userreview";
import UserSettings from "./pages/usersettings";
import Login from "../authentication/login";

const UserDashboard = () => {
  let t = localStorage.getItem('userMenu');
  if (!t) {
    t = 'bookings';
  }
  const [actMenu, setActMenu] = useState(t);
  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    const t = localStorage.getItem('uToken');
    if (t) {
      setLoggedIn(true);
    }
    Aos.init({ duration: 1200, once: true });
  }, []);

  function checkIfLoggedInAgain(v) {
    const t = localStorage.getItem('uToken');
    if (t) {
      setLoggedIn(true);
    } else {
      setLoggedIn(false);
    }
    return v;
  }

  if (!loggedIn) {
    return (
      <div>
        <Login
          checkIfLoggedIn={checkIfLoggedInAgain}
          message={`Please Login to continue to Profile.`}
        />
      </div>
    );
  }
  return (
    <>
      <Breadcrumbs title="User Dashboard" subtitle="User Dashboard" />
      <DashboardMenu actMenu={actMenu} setActMenu={setActMenu} setLoggedIn={setLoggedIn} />
      {actMenu === 'dashboard' && <UserDashboardOnly />}
      {actMenu === 'bookings' && <UserBookingsNew />}
      {actMenu === 'payments' && <UserTransactions />}
      {actMenu === 'reviews' && <UserReview />}
      {actMenu === 'settings' && <UserSettings />}
    </>
  );
};

export default UserDashboard;
